<template>
    <HeaderList></HeaderList>
    <div class="category relative pt-12 h-max bg-theme-gray flex">
        <SearchResult></SearchResult> 
        
    </div>
</template>

<script>
import HeaderList from '@/components/HeaderList.vue';
import SearchResult from '@/components/SearchResult.vue';



export default {
    name: 'category',
    components: {
        HeaderList,
        SearchResult,

    }
};
</script>